import { useState, useEffect } from 'react'
import { motion } from 'framer-motion'


export default function AnimatedLoadingScreen({message}: {message: string}) {
    const [progress, setProgress] = useState(0)

    useEffect(() => {
        const timer = setInterval(() => {
            setProgress((oldProgress) => {
                const newProgress = Math.min(oldProgress + Math.random() * 10, 99)
                if (newProgress === 99) {
                    clearInterval(timer)
                }
                return newProgress
            })
        }, 800)

        return () => clearInterval(timer)
    }, [])

    const cogVariants = {
        rotate: {
            rotate: 360,
            transition: {
                duration: 4,
                repeat: Infinity,
                ease: "linear"
            }
        }
    }

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-br from-pink-100 to-purple-100">
            <div className="w-64 h-64 relative">
                <svg className="w-full h-full" viewBox="0 0 100 100">
                    <circle
                        className="text-pink-200 stroke-current"
                        strokeWidth="8"
                        cx="50"
                        cy="50"
                        r="40"
                        fill="transparent"
                    />
                    <circle
                        className="text-purple-500 stroke-current"
                        strokeWidth="8"
                        strokeLinecap="round"
                        cx="50"
                        cy="50"
                        r="40"
                        fill="transparent"
                        strokeDasharray="251.2"
                        strokeDashoffset={251.2 * (1 - progress / 99)}
                        style={{ transition: 'stroke-dashoffset 0.35s' }}
                    />
                </svg>
                <motion.div
                    className="absolute inset-0 flex items-center justify-center"
                    variants={cogVariants}
                    animate="rotate"
                >
                    <svg className="w-24 h-24 text-purple-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                    </svg>
                </motion.div>
            </div>
            <div className="mt-4 text-2xl font-bold text-purple-700">{message}</div>
            <div className="mt-2 text-lg text-pink-600">{Math.round(progress)}%</div>
        </div>
    )
}